import { Users, Building2, TrendingUp, BarChart3, Activity, LineChart, RotateCw, ShoppingCart, Gem, Megaphone, FlaskConical, Shapes } from 'lucide-react';

const BASE_SECTIONS = [
  { id: 'users', name: 'Пользователи', icon: Users },
  { id: 'iap', name: 'Инапы', icon: ShoppingCart },
  { id: 'resources', name: 'Ресурсы', icon: Gem },
  { id: 'ads', name: 'Реклама', icon: Megaphone },
  { id: 'companies', name: 'Кампании', icon: Building2 },
  { id: 'ltv', name: 'LTV', icon: TrendingUp },
  { id: 'roas', name: 'ROAS', icon: BarChart3 },
  { id: 'sessions', name: 'Сессии', icon: Activity },
  { id: 'progression', name: 'Прогрессия', icon: LineChart },
  { id: 'retention', name: 'Retention', icon: RotateCw },
  { id: 'abtest', name: 'A/B тесты', icon: FlaskConical }
];

// Пункт «Прототипы» — только косметика: доступ к данным закрыт на сервере
export const getNavSections = (user) => (
  user?.canViewPrototypes
    ? [...BASE_SECTIONS, { id: 'prototypes', name: 'Прототипы', icon: Shapes }]
    : BASE_SECTIONS
);
